import { configureStore } from '@reduxjs/toolkit';
import appSlice from './app/app-slice';
import authSlice from './auth/auth-slice';
import issuesSlice from './issue/issues-slice';
import documentsSlice from './document/documents-slice';
import shareSlice from './share/share-slice';

const store = configureStore({
  reducer: {
    app: appSlice.reducer,
    auth: authSlice.reducer,
    issues: issuesSlice.reducer,
    documents: documentsSlice.reducer,
    share: shareSlice.reducer,
  },
  devTools: true,
});
export default store;
